export default "__VITE_ASSET__BA4Ptm4u__"